export default __webpack_public_path__ + "static/media/no-jobs.e1a24185.jpeg";